// LOCAL
const urlBase = "/";
// PRUEBAS MALASYA
// const urlBase = "/servicios5/";

// let URL_IMAGE_GEOMEDELLIN = `https://www.medellin.gov.co/${urlBase}apigeomedellin/atributos/archivos`;
let URL_IMAGE_GEOMEDELLIN = `${urlBase}apigeomedellin/atributos/archivos`;

//let URL_MAPGIS_SEG = "https://www.medellin.gov.co/mapgis_seg/";
let URL_MAPGIS_SEG = "/mapgis_seg/";

if (process.env.NODE_ENV === "development") {
  URL_IMAGE_GEOMEDELLIN = `${urlBase}apigeomedellin/atributos/archivos`;

  // URL_MAPGIS_SEG = "http://localhost:8888/mapgis_seg/";
  // URL_MAPGIS_SEG = "https://www.medellin.gov.co/mapgis_seg/";
  // URL_MAPGIS_SEG = "https://www.medellin.gov.co/servicios/dev9/mapgis_seg/";
  URL_MAPGIS_SEG = "/mapgis_seg/";
}
if (process.env.NODE_ENV === "production") {
  //URL_IMAGE_GEOMEDELLIN = `https://www.medellin.gov.co/${urlBase}apigeomedellin/atributos/archivos`;
  //URL_MAPGIS_SEG = "https://www.medellin.gov.co/servicios/dev9/mapgis_seg/";
  // URL_MAPGIS_SEG = "https://www.medellin.gov.co/mapgis_seg/";
}

export { URL_IMAGE_GEOMEDELLIN, URL_MAPGIS_SEG };
